/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import React from 'react';

import * as analytics from 'analytics/Analytics';
import {setLocationHref} from 'BenchlingUtil';
import * as nyc from 'ui-library/NYC';

type State = any;

class HomeSidepanelSignedOut extends React.Component<{}, State> {
  override state: State = {email: ''};

  _handleEmailChange = (e: any): void => {
    this.setState({email: e.target.value});
  };

  _handleSubmit = (e: any): void => {
    if (e.key === 'Enter') {
      this._handleClickSignup();
    }
  };

  _handleClickSignup = (): void => {
    analytics.track('benchling', 'initiated_signup', {
      email: this.state.email,
      signup_source: 'signed out view',
    });
    setLocationHref(`/signup?email=${encodeURIComponent(this.state.email)}`);
  };

  _handleClickLogin = (): void => {
    setLocationHref(`/signin?username=${encodeURIComponent(this.state.email)}`);
  };

  override render(): JSX.Element {
    return (
      <nyc.Row className="homeSidepanel-signedOut">
        <nyc.Col sm={6}>
          <h1>Welcome to Benchling</h1>
          <p className="homeSidepanel-signedOut-description">
            Benchling is an intelligent research platform with tools for note-taking, molecular biology, and
            sample tracking.
          </p>

          <h3>Create an account</h3>

          <div className="homeSidepanel-signedOut-signupForm">
            <div>Email</div>
            <input value={this.state.email} onChange={this._handleEmailChange} onKeyUp={this._handleSubmit} />
          </div>

          <div className="u-lr-split">
            <div>
              <div className="homeSidepanel-signedOut-loginDesc">Already have an account?</div>
              <div>
                <a className="homeSidepanel-signedOut-login" onClick={this._handleClickLogin}>
                  Sign in
                </a>
              </div>
            </div>
            <div>
              <button
                className="button button--medium button--primary"
                onClick={this._handleClickSignup}
                type="button"
              >
                Sign up
              </button>
            </div>
          </div>
        </nyc.Col>
      </nyc.Row>
    );
  }
}

export default HomeSidepanelSignedOut;
